import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-sort"
export default class extends Controller {
  static targets = [ "sortableItem" ];
  static values = {
    style: String,

    // For remote
    model: String,
    prefix: String,

    // For local
    positionFieldName: { type: String, default: "position" }
  };

  draggedItem = null;
  insertedBefore = null;

  connect() {
    this.boundDragStart = this.dragStart.bind(this);
    this.boundDragOver = this.dragOver.bind(this);
    this.boundDragEnd = this.dragEnd.bind(this);

    this.element.addEventListener('dragstart', this.boundDragStart);
    this.element.addEventListener('dragover', this.boundDragOver);
    this.element.addEventListener('dragend', this.boundDragEnd);
  }

  disconnect() {
    this.element.removeEventListener('dragstart', this.boundDragStart);
    this.element.removeEventListener('dragover', this.boundDragOver);
    this.element.removeEventListener('dragend', this.boundDragEnd);
  }

  sortableItemTargetConnected(el) {
    el.draggable = true;
  }

  sortableItemTargetDisconnected(el) {
    el.draggable = false;
  }

  dragStart(ev) {
    if (this.sortableItemTargets.includes(ev.target)) {
      this.draggedItem = ev.target;
      ev.dataTransfer.effectAllowed = 'move';
      this.draggedItem.style.opacity = "0.6";
    }
  }

  dragOver(ev) {
    if (this.sortableItemTargets.includes(this.draggedItem)) {
      ev.preventDefault();
      ev.dataTransfer.dropEffect = 'move';

      const closest = ev.target.closest("[data-table-sort-target='sortableItem']");
      if (closest !== this.draggedItem) {
        const midpoint = closest.offsetHeight / 2;
        let willInsertBefore = null;

        if (ev.offsetY < midpoint) {
          willInsertBefore = closest;
        } else {
          willInsertBefore = closest.nextElementSibling;
        }

        if (willInsertBefore != this.insertedBefore) {
          this.element.insertBefore(this.draggedItem, willInsertBefore);
          this.insertedBefore = willInsertBefore;
        }
      }
    }
  }            

  dragEnd(ev) {
    if (this.sortableItemTargets.includes(this.draggedItem)) {
      this.draggedItem.style.opacity = "";
      this.draggedItem = null;
      this.insertedBefore = null;
      if (this.styleValue == 'remote') {
        this.send_remote();
      } else {
        this.sort_local();
      }
    }
  }

  send_remote() {
    const _self = this;

    const pre_path = this.prefixValue || '/admin';
    const url = pre_path + '/' + this.modelValue + '/sort';

    const csrfToken = document.getElementsByTagName('meta')['csrf-token'].content;

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': csrfToken
      },
      body: _self.sortable_serialize(_self.element.children)
    }).then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        alert('Your sort failed!');
      }
    }).then((text) => {
    }).catch((error) => {
      alert("Your sort failed!");
    });
  }

  sortable_serialize(elements) {
    let matchData = Array.from(elements).map(el => el.id.match(/^(.+)[-_](.+)$/));
  
    var formData = new FormData();
    matchData.forEach(function(match) {
      formData.append(`${match[1]}[]`, match[2]);
    });
  
    return formData;
  }

  sort_local() {
    let idx = 0;
    const _self = this;
    this.sortableItemTargets.forEach(item => {
      const position_field = item.querySelector(`input[name$="[${_self.positionFieldNameValue}]"]`);
      if (position_field) {
        position_field.value = idx;
        idx++;
      }
    });    
  }
}
